/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import {
  QCTaskPatientState,
  QCTaskPatientFetchAction,
  QCTaskPatientFetchSuccessAction,
  QCTaskPatientChangePatientStatusAction,
  QCTaskPatientUpdateDobAction,
  QCTaskPatientUpdateDobSuccessAction,
  QCTaskPatientUpdateSiteAction,
  QCTaskPatientUpdateSiteSuccessAction,
  QCTaskPatientUpdatePatientCodeSuccessAction,
  QCTaskPatientUpdatePatientCodeAction,
} from './QCTaskPatient.types';
import { createSliceHook, ErrorAction } from '../helpers';

const initialState: QCTaskPatientState = {
  loading: false,
  data: null,
  statusLoading: false,
  error: undefined,
  statusError: undefined,
};

export const QCTaskPatientSlice = createSlice({
  name: 'QCTaskPatient',
  initialState,
  reducers: {
    fetchQCTaskPatient: (state, action: QCTaskPatientFetchAction) => {
      state.loading = true;
    },
    fetchQCTaskPatientSuccess: (
      state,
      action: QCTaskPatientFetchSuccessAction
    ) => {
      state.data = action.payload;
      state.loading = false;
    },
    fetchQCTaskPatientFailure: (state, action: ErrorAction) => {
      state.error = action.payload;
      state.loading = false;
    },

    changePatientStatus: (
      state,
      action: QCTaskPatientChangePatientStatusAction
    ) => {
      state.statusLoading = true;
    },
    changePatientStatusFailure: (state, action: ErrorAction) => {
      state.statusError = action.payload.message;
      state.statusLoading = false;
    },

    changePatientStatusSuccess: (state, action) => {
      if (state.data) {
        state.data.uploadStatus = action.payload;
      }
      state.statusLoading = false;
    },

    // ✅ DOB update reducers
    updatePatientDob: (state, action: QCTaskPatientUpdateDobAction) => {
      state.statusLoading = true;
    },
    updatePatientDobSuccess: (
      state,
      action: QCTaskPatientUpdateDobSuccessAction
    ) => {
      state.statusLoading = false;
      if (state.data) {
        state.data.dob = action.payload;
      }
    },
    updatePatientDobFailure: (state, action: ErrorAction) => {
      state.statusLoading = false;
      state.statusError = action.payload.message;
    },

    updatePatientSite: (state, action: QCTaskPatientUpdateSiteAction) => {
      state.statusLoading = true;
    },
    updatePatientSiteSuccess: (
      state,
      action: QCTaskPatientUpdateSiteSuccessAction
    ) => {
      state.statusLoading = false;
      if (state.data) {
        state.data.siteId = action.payload;
      }
    },
    updatePatientSiteFailure: (state, action: ErrorAction) => {
      state.statusLoading = false;
      state.statusError = action.payload.message;
    },

    updatePatientCode: (state, action: QCTaskPatientUpdatePatientCodeAction) => {
      state.statusLoading = true;
    },
    updatePatientCodeSuccess: (
      state,
      action: QCTaskPatientUpdatePatientCodeSuccessAction
    ) => {
      state.statusLoading = false;
      if (state.data) {
        state.data.patientCode = action.payload;
      }
    },
    updatePatientCodeFailure: (state, action: ErrorAction) => {
      state.statusLoading = false;
      state.statusError = action.payload.message;
    },

    clear: state => {
      state.data = null;
    },
  },
});

export const {
  fetchQCTaskPatient,
  fetchQCTaskPatientSuccess,
  fetchQCTaskPatientFailure,
  changePatientStatus,
  changePatientStatusSuccess,
  updatePatientDob,
  updatePatientDobSuccess,
  updatePatientDobFailure,
  updatePatientSite,
  updatePatientSiteSuccess,
  updatePatientSiteFailure,
  updatePatientCode,
  updatePatientCodeSuccess,
  updatePatientCodeFailure,
} = QCTaskPatientSlice.actions;

export const actions = {
  ...QCTaskPatientSlice.actions,
};

export const useQCTaskPatientSlice = createSliceHook(
  QCTaskPatientSlice.name,
  actions
);
